/**
 * Pop Up - Variant popup trigger handle
 */

export default function PopUp() {
	const selectors = {
        popupDelaySecond: "popup_delay",
        popupTriggerPoint: "scroll_trigger",
        popupCookie: "popup_cookie",
        popupCookieExpirationTime : "popup_expiration",
        popupContainer: ".pagepopup-container"
    };

	this.init = () => {
		triggerPopUpPosition();
    };

    const triggerPopUpPosition = () => {
        const observer = new IntersectionObserver(intersectionCallback);
        const triggerElement = document.getElementById(selectors.popupTriggerPoint);
        if (triggerElement)
            observer.observe(triggerElement);
    }

    const intersectionCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                showPopUp();
                observer.disconnect()
            }
        });
    }

    const showPopUp = () => {
        const delayTime = document.getElementById(selectors.popupDelaySecond).getAttribute("value");
        const cookie = document.getElementById(selectors.popupCookie).getAttribute("value");
        const cookieExpirationTime = document.getElementById(selectors.popupCookieExpirationTime).getAttribute("value");

        if ( $.cookie(cookie) == null ) {
            var date = new Date();
            setTimeout ( function() {
                $(selectors.popupContainer).addClass('modal-show');
                $.cookie(cookie, 1, { expires : date.getTime() + cookieExpirationTime * 24 * 60 * 60 * 1000 });
            }, delayTime * 1000)
        }
    }
}